module.exports = __webpack_public_path__ + "img/logo.afca5ad8.png";